import { render } from "./klb-q1.vue?vue&type=template&id=66406606&scoped=true"
import script from "./klb-q1.vue?vue&type=script&lang=js"
export * from "./klb-q1.vue?vue&type=script&lang=js"

import "./klb-q1.vue?vue&type=style&index=0&id=66406606&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66406606"]])

export default __exports__